module.exports = __webpack_public_path__ + "static/img/turntable.d4f37a38.png";